// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoyFeatures_wrapper__Bwdfd","content":"RoyFeatures_content__CW9Lr","title":"RoyFeatures_title__2B98_","columns":"RoyFeatures_columns__LVl8d"};